import React, { useState, useContext, useRef } from "react";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import { toastShow } from "../../../../Base/Services/ToastService";
import { AgregarRetorno } from "../../../../API/Logistica/PasesSalidaRequest";

const ListadoPasesDet = ({ listadoDet, selectedDet, setSelectedDet, setShowDialog, setSelectedEnc, PendienteRetorno = false, toast, getInfo }) => {
  const { userAuth } = useContext(AuthContext);

  const agregarRetorno = (data) => {  
    let Detalles
    if (selectedDet.length > 0) {
      Detalles = selectedDet
    } else {
      Detalles = [data]
    }
    confirmDialog({
      message: `¿Agregar retorno a ${Detalles?.length} Detalles de Pases de Salida ?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        agregar(Detalles);
      },
      reject: () => {},
    });
  };

  const agregar = async (changes) => {
    for (const detalle of changes) {
      const detalles = {
        ...detalle,
        IdUserRetorna: userAuth?.IdUser,
      };
      await AgregarRetorno(detalles);
    }
    toastShow(toast, "success", "Agregado", "Retorno agregado correctamente.");
    getInfo();
    setSelectedDet([]);
  };

  

  const columns = [
    {
      field: "IdPaseDet",
      header: "ID",
      headerEn: "ID",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaCreacion2",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
    },
    {
      field: "NoPaseSalida",
      headerEn: "No. Pase",
      header: "No. Pase",
      className: "small",
      body: (rowData) => rowData.NoPaseSalida,
      Format: "Modal",
      frozen: true,
      Sumary: "count",
      onCellDoubleClicked: ({ data }) => {
        if(!PendienteRetorno){
          AbrirPase(data);
        }
      },
    },
    !PendienteRetorno ?
    {
      field: "StatusName",
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdEstadoEnc === 61 ? rowData.IdEstadoEnc : rowData.IdEstado,
        Estado:
          rowData.IdEstadoEnc === 61
            ? rowData.StatusNameEnc
            : rowData.StatusName,
      }),
      align: "center",
      Format: "Estado",
    } : null,
    {
      headerName: "Activo Fijo",
      children: [
        {
          // Area
          field: "CodigoActivo",
          header: "Codigo Act",
          headerEn: "Code Ac",
          className: "small",
        },
        {
          // Area
          field: "NombreActivo",
          header: "Activo",
          headerEn: "Activo",
          className: "large",
        },
        {
          // Area
          field: "Marca",
          header: "Marca",
          headerEn: "Marca",
          className: "small",
        },
        {
          // Area
          field: "Modelo",
          header: "Modelo",
          headerEn: "Modelo",
          className: "small",
        },
        {
          // Area
          field: "Serie",
          header: "Serie",
          headerEn: "Serie",
          className: "small",
        },
        {
          // Area
          field: "Ano",
          header: "Año",
          headerEn: "Year",
          className: "Xsmall",
        },
      ],
    },

    {
      headerName: "Producto",
      children: [
        {
          // Area
          field: "CodigoProducto",
          header: "Codigo",
          headerEn: "Code",
          className: "small",
        },
        {
          field: "NombreProducto",
          header: "Producto",
          headerEn: "Producto",
          className: "large",
        },
        {
          field: "DescripcionProducto",
          header: "Descripción",
          headerEn: "Description",
          className: "large",
        },
        {
          header: "Tipo Producto",
          headerEn: "Product Type",
          field: "NombreCategoria",
          className: "small",
        },
        {
          header: "Categoría",
          headerEn: "Category",
          field: "NombreSubcategoria",
          className: "medium",
        },
        {
          header: "Sub-Categoría",
          headerEn: "Sub-Category",
          field: "NombreTipoProducto",
          className: "medium",
        },
      ],
    },

    {
      headerName: "Ingreso",
      children: [
        {
          field: "NumeroIngreso",
          header: "Ingreso",
          headerEn: "Income",
          className: "small",
        },
        {
          // Comment
          field: "CodigoProductoI",
          header: "Código",
          headerEn: "Code",
          className: "Xsmall",
        },
        {
          // Comment
          field: "NombreProductoI",
          header: "Nombre Producto",
          headerEn: "Product Name",
          className: "Xlarge",
        },
        {
          // Comment
          field: "NombreCategoriaI",
          header: "Tipo Producto",
          headerEn: "Product Type",
          className: "small",
        },
        {
          // Comment
          field: "NombreSubcategoriaI",
          header: "Categoría",
          headerEn: "Category",
          className: "small",
        },
        {
          // Comment
          field: "NombreTipoProductoI",
          header: "Categoría",
          headerEn: "Category",
          className: "small",
        },
      ],
    },

    {
      headerName: "Otro",
      children: [
        {
          field: "Comentario",
          header: "Comentario",
          headerEn: "Comment",
          className: "XXlarge",
        },
      ],
    },

    {
      field: "Peso",
      header: "Peso",
      headerEn: "Peso",
      className: "small",
      Format: "Currency",
      Sumary: "sum,",
    },
    {
      field: "Cantidad",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum,",
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
    },
    {
      field: "UsuarioCreate",
      header: "Usuario Creación",
      headerEn: "User Create",
      className: "medium",
      body: (rowData) => rowData.UserNameCreate,
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      className: "XXlarge",
      body: (rowData) => rowData.Comment,
    },
    {
      headerName: "Retorno",
      children: [
        {
          field: "FechaRetornoTent",
          header: "Fecha Tentativa Retorno",
          headerEn: "Fecha Tentativa Retorno",
          className: "medium",
          body: (rowData) => rowData.FechaRetornoTent,
          frozen: PendienteRetorno,
          alignFrozen: PendienteRetorno ? "right" : null,
          Format: "Date",
        },
        {
          field: "Retorna",
          header: "Retorna",
          headerEn: "Retorna",
          className: "Xsmall",
          align: "center",
          Format: "Template",
          filter: false,
          frozen: PendienteRetorno,
          alignFrozen: PendienteRetorno ? "right" : null,
          body: (rowData) => {
            return rowData.IdPase ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "2px",
                }}
              >
                <Checkbox checked={rowData.Retorna === true} />
              </div>
            ) : null;
          },
        },
        {
          field: "FechaRetorno",
          header: "Fecha Retorno",
          headerEn: "Fecha Retorno",
          className: "medium",
          hidden: !PendienteRetorno,
          Format: "DateTime",
        },
        {
          field: "UserNameRetorna",
          header: "Usuario Retorno",
          headerEn: "User Return",
          hidden: !PendienteRetorno,
          className: "small",
        },
        PendienteRetorno
          ? {
              field: "IdPaseDet",
              header: "",
              Format: "Botones",
              filter: false,
              frozen: 1,
              alignFrozen: "right",
              Botones: [
                {
                  icon: "ri-history-line",
                  tooltip: "Agregar Retorno",
                  tooltipOptions: { position: "left" },
                  onClick: (rowData) => {
                    if (rowData?.IdPaseDet) {
                      agregarRetorno(rowData);
                    }
                  },
                },
              ],
            }
        : null,
      ],
    },
  ];

  const AbrirPase = (data) => {
    setSelectedEnc(data);
    setShowDialog(true);
    // showModal('ingreso'); 
  };

  const table = {
    Columns: columns,
    Data: listadoDet,
    showModal: (e) => showModal(e),
    key: "IdPaseDet",
    selected: selectedDet,
    setSelected: (e) => setSelectedDet(e),
  };
  


  const showModal = (PurchaseRequest) => {
    // setPurchaseShow(PurchaseRequest);
    // setRequisaDialog(true);
  };
  // Fecha

  return (
    <div style={{width: "100%"}}>
      <div style={{ height: "83vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default ListadoPasesDet;
